import React, { useState } from "react";
import { ScrollableTable } from "./Tables/ScrollableTable";
import { confirmDeletionModal } from "./common/ConfirmationModal";
import {
  editKnowledgeBaseForm,
  FileType,
  KnowledgeBaseDocumentType,
} from "src/interfaces/KnowledgeBase";
import { showNotification } from "@mantine/notifications";
import ManualUploadEditForm from "./UploadForms/ManualUploadForm/ManualUploadEditForm";

interface UploadDocsProps {
  files: KnowledgeBaseDocumentType[];
  onPressDownload: (fileName: string) => void;
  onRefresh: () => void;
  deleteSingleFile: (
    fileName: string,
    subject: string,
    is_qb?: boolean
  ) => void;
  loading?: boolean;
}

const ManageDocs: React.FC<UploadDocsProps> = (props) => {
  const { files, onPressDownload, onRefresh, deleteSingleFile, loading = false } = props;
  const [isEditing, setIsEditing] = useState(false);
  const [editFileData, setEditFileData] = useState<
    editKnowledgeBaseForm | undefined
  >(undefined);

  const handleUploadSuccess = (message?: string) => {
    showNotification({
      title: "Success",
      message: message || "File updated successfully!",
      color: "green",
    });
    onRefresh();
  };

  const handleUploadError = (error: string) => {
    showNotification({
      title: "Error",
      message: error,
      color: "red",
    });
  };

  const deleteOneFile = (name: string, subject: string, is_qb?: boolean) => {
    confirmDeletionModal({
      title: "Deleting file",
      feedback: "You are about to delete this file",
      onClose: () => {},
      onConfirm: () => deleteSingleFile(name, subject, is_qb),
    });
  };

  const editOneFile = (name: string) => {
    const file = files.find((file) => file.document_name === name);
    if (!file) return;
    setIsEditing(true);
    const editFileData = {
      type: file.is_qb ? "Question Bank" : "Knowledge",
      level: file.level,
      subject: file.subject,
      summary: file.summary,
      fileName: file.document_name,
      currentStep: 2,
    };
    setEditFileData(editFileData);
  };

  return (
    <>
      {isEditing ? (
        <ManualUploadEditForm
          onSuccess={handleUploadSuccess}
          onError={handleUploadError}
          editFileData={editFileData}
          setIsEditing={setIsEditing}
        />
      ) : (
        <ScrollableTable
          onDownload={onPressDownload}
          data={files}
          onSingleDelete={deleteOneFile}
          onRefresh={onRefresh}
          editOneFile={editOneFile}
          loading={loading}
        />
      )}
    </>
  );
};

export default ManageDocs;
